<template>
  <div class="product-content custom-product">
    <div
      class="notify fade"
      v-if="notification"
      :class="notification_type"
      @click="notification=false"
    >{{notification}}</div>
    <mq-layout class="container is-boxed-fluid" :mq="['xl', 'hd', 'inf']">
      <div class="page-headline">
        <div class="row ns between">
          <div class="col-6">
            <ul class="breadcrumbs">
              <li v-for="(item, key) in page.data.breadcrumbs">
                <router-link :to="item.slug">{{item.name}}</router-link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </mq-layout>

    <div class="container is-boxed-fluid product">
      <div class="row">
        <div class="col-8 col-md-12 product-images fade" v-show="!page.loading">
          <div class="row gut-2">
            <div
              class="col-6 col-md-12"
              v-for="(image, key) in page.data.product.images"
              :key="key"
            >
              <img :src="image.img_name" alt />
            </div>
          </div>
        </div>
        <div class="col-8 col-md-12 product-images-loading fade" v-show="page.loading">
          <div class="row gut-2">
            <div class="col-6 col-md-12">
              <div class="loading"></div>
            </div>
            <div class="col-6 col-md-12">
              <div class="loading"></div>
            </div>
            <div class="col-6 col-md-12">
              <div class="loading"></div>
            </div>
            <div class="col-6 col-md-12">
              <div class="loading"></div>
            </div>
          </div>
        </div>
        <div class="col-4 col-md-12 product-summary fade" v-show="!page.loading">
          <div class="product-info">
            <h1 class="title">{{page.data.product.title}}</h1>
            <p class="price">{{page.data.product.price}} AMD</p>
            <p class="sku">{{page.data.product.sku}}</p>
            <div class="attributes">
              <component
                :is="attribute.component"
                @set_attribute="set_attribute"
                v-for="(attribute, key_1) in page.data.product.attributes"
                :key="attribute.id"
                :filter="attribute"
              ></component>
            </div>
            <!--<div class="find-your-size">-->
            <!--<span>Find Your Size</span>-->
            <!--</div>-->
            <div class="add-to-cart">
              <button
                class="button"
                :class="{loading: adding_to_cart}"
                :disabled="adding_to"
                @click="add_to_cart()"
              >ԱՎԵԼԱՑՆԵԼ ԶԱՄԲՅՈՒՂ</button>
              <button class="button favorite" :disabled="adding_to" @click="add_to_favorites()">
                <i class="icon-favorite"></i>
              </button>
            </div>
            <br />
            <!--<span @click="reset_cart()">RESET CART</span>-->
            <div class="accordion">
              <ul>
                <li v-for="(item, key) in page.product.accordion" :key="key">
                  <div
                    @click="item.open=!item.open"
                    class="has-toggle"
                    :class="{active: item.open}"
                  >
                    <strong>{{item.title}}</strong>
                    <span class="toggle"></span>
                  </div>
                  <div v-if="item.open">
                    <p>{{item.content}}</p>
                  </div>
                </li>
              </ul>
            </div>
            <!--<div class="social-share">-->
            <!--<span>Share on social media</span>-->
            <!--<ul>-->
            <!--<li><i class="icon-facebook"></i></li>-->
            <!--</ul>-->
            <!--</div>-->
          </div>
        </div>
        <div class="col-4 col-md-12 prdouct-summary-loading fade" v-show="page.loading">
          <ul>
            <li class="loading"></li>
            <li class="loading"></li>
            <li class="loading"></li>
            <li class="loading"></li>
            <li class="loading"></li>
            <li class="loading"></li>
            <li class="loading"></li>
            <li class="loading"></li>
          </ul>
        </div>
      </div>
    </div>
    <slider :component="'product'" :items="products" :title="'Լրացրեք ձեր տեսքը\n'" :badge="false"></slider>
    <slider
      :component="'product'"
      :items="products"
      :title="'Ձեզ հնարավոր է նաեւ դուր գա'"
      :badge="false"
    ></slider>
  </div>
</template>

<script>
import Slider from '@/components/home/Slider.vue';
import Color from '@/components/shop/attributes/Color.vue';
import Size from '@/components/shop/attributes/Size.vue';
import Listing from '@/components/shop/filters/Listing.vue';
import { mapState } from 'vuex';

export default {
  components: {
    Slider,
    Listing,
    Color,
    Size
  },
  data () {
    return {
      adding_to: false,
      adding_to_cart: false,
      adding_message: '',
      products: [
        {
          id: 2100,
          image:
            'http://app.petoor.com/uploads/products/425/078cb33b1688ae8141e64c9ebab3f8c6.jpeg',
          title: 'Պիջակ «Art Deco»',
          price: '25,000 AMD'
        },
        {
          id: 2101,
          image:
            'http://app.petoor.com/uploads/products/425/cfa4eec742ef5a0aebdd1567d2393627.jpeg',
          title: 'Պիջակ «Կաշվի ելևէջներ»',
          price: '22,000 AMD'
        },
        {
          id: 2094,
          image:
            'http://app.petoor.com/uploads/products/425/84aa8ddfb52a00459b31bb7991ba3f31.jpeg',
          title: 'Սև շապիկ կարմիր գրպանով',
          price: '19,000 AMD'
        },
        {
          id: 2091,
          image:
            'http://app.petoor.com/uploads/products/425/f17d048383111a64d597f4a7e75b2e31.jpeg',
          title: 'Vanity շապիկ',
          price: '18,000 AMD'
        },
        {
          id: 2093,
          image:
            'http://app.petoor.com/uploads/products/425/389d47c7805406dea881782e7e603709.jpeg',
          title: 'Շապիկ ջրահարս',
          price: '22,000 AMD'
        },
        {
          id: 2092,
          image:
            'http://app.petoor.com/uploads/products/425/530809f8b52269c5f08ccd6d0880f697.jpeg',
          title: 'Շապիկ Inspired by vogue',
          price: '91 000 AMD'
        }
      ],
      notification: false,
      notification_type: 'success',
      add_to_cart_timeout: null,
      notification_timeout: null,
      selected_attributes: {}
    }
  },
  methods: {
    notify (notification, type = 'success', time = 1500) {
      var self = this
      self.notification = notification
      self.notification_type = type
      clearTimeout(this.notification_timeout)
      self.notification_timeout = setTimeout(function () {
        self.notification = false
      }, time)
    },
    reset_cart () {
      this.$store.dispatch('resetCart')
    },
    generate_cart_item_id () {
      var selected_attrs = []
      if (Object.keys(this.selected_attributes).length > 0) {
        for (var key in this.selected_attributes) {
          selected_attrs.unshift(this.selected_attributes[key].id)
        }
      } else {
        selected_attrs.push(this.page.data.product.id)
      }
      return selected_attrs.join('-')
    },
    set_attribute (option, key) {
      this.selected_attributes[key] = {
        id: option.id,
        value: option.key
      }
    },
    save_cart_item () {
      if (!this.adding_to) {
        var self = this
        this.adding_to = true
        this.adding_to_cart = true
        this.adding_message = 'Added to cart';
        this.page.data.product.qty = 1

        let cart_item = {
          qty: 1,
          item_id: this.generate_cart_item_id(),
          product_id: this.page.data.product.id,
          sku: this.page.data.product.sku,
          title: this.page.data.product.title,
          price: this.page.data.product.price,
          image: this.page.data.product.image,
          attributes: Object.assign({}, this.selected_attributes)
        }

        console.log(cart_item)

        this.$store.dispatch('fetchCartItem', cart_item)
        clearTimeout(this.add_to_cart_timeout)
        this.add_to_cart_timeout = setTimeout(function () {
          self.adding_to = false
          self.adding_to_cart = false
          self.notify('Added to cart', 'success', 3000)
        }, 500)
      }
    },
    add_to_cart () {
      var current_product_attributes_count = Object.keys(
        this.page.data.product.attributes
      ).length
      var selected_attributes_count = Object.keys(this.selected_attributes)
        .length

      if (current_product_attributes_count > 0) {
        if (selected_attributes_count == current_product_attributes_count) {
          this.save_cart_item()
        } else {
          var selected_attr
          for (var key in this.page.data.product.attributes) {
            if (
              !this.selected_attributes.hasOwnProperty(
                this.page.data.product.attributes[key].name
              )
            ) {
              this.notify(
                this.page.data.product.attributes[key].name + ' not selected',
                'error',
                5000
              )
              break;
            }
          }
        }
      } else {
        this.save_cart_item()
      }
    },
    add_to_favorites () {
      if (!this.adding_to) {
        var self = this
        self.adding_to = true
        self.adding_message = 'Added to favorites';
        self.$store.dispatch('fetchFavoriteItem', this.page.data.product.id)
        clearTimeout(this.add_to_cart_timeout)
        self.add_to_cart_timeout = setTimeout(function () {
          self.adding_to = false
          self.notify('Added to favorites', 'success', 1500)
        }, 300)
      }
    }
  },
  beforeMount () {
    this.$store.dispatch('fetchPage', {
      product: {}
    })
  },
  computed: mapState(['page'])
}
</script>

<style lang="scss">
.custom-product {
}
</style>
